import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../../helper/api";

export const riskFreeBetsList = createAsyncThunk(
  "riskFreeBetsList/riskFreeBetsList",
  async (payload, thunkAPI) => {
    try {
      const response = await api.post("risk-free-bets/get-all", payload);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue("Something went wrong");
    }
  }
);

const riskFreeBetSlice = createSlice({
  name: "riskFreeBetsList",
  initialState: {
    data: null,
    loading: false,
    error: null,
  },

  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(riskFreeBetsList.pending, (state) => {
        state.loading = true;
      })
      .addCase(riskFreeBetsList.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(riskFreeBetsList.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
});

export default riskFreeBetSlice.reducer;
